@if (isInlineEditor) {
  <div class="input-container">
    @switch (valueFormat) {
      @case ('Paragraph') {
        <div class="paragraph-expand-container">
          <div class="paragraph-expand" (click)="openParagraph($event)">
            <mat-icon svgIcon="arrow_forward" />
          </div>
        </div>
        <textarea
          #stringInput
          #autosize="cdkTextareaAutosize"
          class="string-input textarea-input"
          [formControl]="formControl"
          cdkTextareaAutosize
          cdkAutosizeMaxRows="130"
          cdkAutosizeMinRows="13"
          ngPreserveWhitespaces
          (blur)="focusOut($event)"
        ></textarea>
      }
      @case ('PhoneNumber') {
        <be-phone-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('Duration') {
        <be-duration-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('GeoPoint') {
        <be-geo-point-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('SecureText') {
        <be-secure-text-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('Currency') {
        <be-currency-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('Percent') {
        <be-percent-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('Number') {
        <be-number-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('Date') {
        <be-datetime-editor
          #datetimeEditor
          [value]="savedErrorValue ?? value"
          [config]="config"
          [layoutMode]="layoutMode"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('DateTime') {
        <be-datetime-editor
          #datetimeEditor
          [value]="savedErrorValue ?? value"
          [config]="config"
          [layoutMode]="layoutMode"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('Time') {
        <be-datetime-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          [layoutMode]="layoutMode"
          (valueChange)="patchValue($event)"
        />
      }
      @case ('Boolean') {
        <be-boolean-editor
          [value]="savedErrorValue ?? value"
          [config]="config"
          (valueChange)="patchValue($event)"
        />
      }
      @default {
        <input
          #stringInput
          type="text"
          class="string-input"
          [formControl]="formControl"
          [ngStyle]="config?.inputStyles"
          (paste)="pasteClipboard($event)"
        />
      }
    }
  </div>
}

@if (editMode === 'menu') {
  <div>
    @switch (menuSwitchValue) {
      @case ('File') {
        <be-file-menu
          [value]="value"
          [config]="config"
          [layoutMode]="layoutMode"
          (valueChange)="emitFileValue($event)"
        />
      }
      @case ('Image') {
        <be-image-menu
          [value]="value"
          [config]="config"
          [layoutMode]="layoutMode"
          (valueChange)="emitFileValue($event)"
        />
      }
      @case ('Tag') {
        <be-tag-menu
          [value]="value"
          [config]="config"
          [layoutMode]="layoutMode"
          (valueChange)="emitFileValue($event)"
        />
      }
      @case ('Link') {
        <be-link-menu
          #linkMenu
          [value]="value"
          [config]="config"
          [layoutMode]="layoutMode"
          (valueChange)="emitFileValue($event)"
        />
      }
      @case ('TimeZone') {
        <be-time-zone-menu
          [value]="value"
          [config]="config"
          [layoutMode]="layoutMode"
          (valueChange)="emitFileValue($event)"
        />
      }
    }
  </div>
}
